<template>
  <div class="page-main">
    <!-- <div class="page-num">
      <span class="left">
        <img src="../../assets/image/left.png" />
      </span>

      <ul class="num" id="pages">
        <li
          v-for="(item,index) in guang.historyPage"
          :key="index"
          @click="changepage"
        >{{item}}</li>
      </ul>
      <span class="right">
        <img src="../../assets/image/right.png" />
      </span>
    </div>
    <div class="topage">
      <span>
        到第
        <input type="text" />页
      </span>
      <span class="ok">确定</span>
    </div>-->
    <el-pagination
      @current-change="handleCurrentChange"
      :page-size="50"
      :current-page.sync="guang.currentPage"
      layout="prev, pager, next, jumper"
      :total="this.guang.total"
    ></el-pagination>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import Tool from "../../assets/commonjs/tool";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(["guang", "login"])
  },
  methods: {
    ...mapMutations({
      showHistory_s_j: "guang/showHistory_s_j",
      showHistory_g_j: "guang/showHistory_g_j"
    }),
    handleCurrentChange(val) {
      // let content = document.getElementById('historycontent')
      let content = document.getElementById('historycontent')
      content.scrollTop = content.scrollHeight;

      // content.scrollTop = 0;

      // let today = new Date(new Date().toLocaleDateString()).getTime();
      let params = {
        userId: this.login.userInfo.itcode,
        recvId: this.guang.recvID,
        currIndex: val,
        pageSize: "",
        startTime: this.guang.startTime,
        endTime: this.guang.endTime
      };
      if (this.guang.downtype == "u") {
        this.showHistory_s_j(params);
      }
      if (this.guang.downtype == "g") {
        this.showHistory_g_j(params);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.page-main {
  margin-top: 20px;
  display: flex;
  padding-left: 60px;
  .page-num {
    margin-right: 34px;
    span {
      text-align: center;
      display: inline-block;
      width: 20px;
      height: 20px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.15);
      border-radius: 1px;
    }
    .left {
      margin-right: 6px;
      img {
        width: 6px;
        height: 10px;
      }
    }
    .right {
      img {
        width: 6px;
        height: 10px;
      }
    }
    .num {
      display: inline-block;
      li {
        width: 20px;
        height: 20px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.15);
        border-radius: 1px;
        margin-right: 6px;
        display: inline-block;
        font-size: 10px;
        font-family: PingFangSC;
        color: rgba(33, 33, 33, 1);
        text-align: center;
      }
    }
  }
  .topage {
    font-size: 10px;
    font-family: PingFangSC;
    color: rgba(33, 33, 33, 1);
    .ok {
      display: inline-block;
      text-align: center;
      width: 32px;
      height: 20px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.15);
      border-radius: 1px;
    }
    input {
      width: 20px;
      height: 20px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.15);
      border-radius: 1px;
      outline: none;
      border: none;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/guang/HistoryPage.vue